export const EP_PROJECT_DRAFT_VERSION = 3;
export const EP_PROJECT_AI_FIELDS = ['contingencyOne', 'contingencyTwo', 'contingencyThree', 'medicalMobiles', 'traumaCentres',
    'closeProtectionCount', 'advanceAgents', 'casevacPrimary', 'casevacAlternate'] as const;
export const epProjectDraftFieldLimit = (key: string) => ['casevacPrimary', 'casevacAlternate', 'medicalMobiles', 'traumaCentres'].includes(key) ? 48000 : 4000;
